import * as React from "react";
import {connect} from "react-redux";
import {withRouter, Link} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import {Button, Table, Panel, FormControl, Row, Col, Alert} from "react-bootstrap";
import {clone, map, range, size, find} from "lodash";
import * as _ from "lodash";
import "react-dates/lib/css/_datepicker.css";
import "font-awesome/less/font-awesome.less";
import "hint.css/hint.css";
import * as moment from "moment";
import {DayPickerRangeController} from "react-dates";

import {loadOrderTicketPrice, HotelAction, updateOrder, setPauseOrdering, getTicketPrice} from "../actions/hotels";
import {ApplicationState} from "../reducers";
import {LoadingOverlay} from "./Loading";
import "./styles/hotels.less";
import {moneyFormat, ticketsForDestination, ZERO_TOTALS} from "../utils";
import {Search, Ticket} from "../models/hotels";
import {TicketMap} from "../reducers/config";
import {Order, OrderTicket, OrderTicketPriceInfo} from "../models/order";
import Cart from "./Cart";

const DL_LOGO = "/img/disneyland.svg";
const DW_LOGO = "/img/disneyworld.svg";
const MIN_FIRST_DATE = moment("2020-07-01T15:08:51-06:00");

interface ActionProps {
    updateOrder: (order: Order) => Promise<HotelAction>;
    setPauseOrdering: (paused: boolean) => HotelAction;
    loadOrderTicketPrice: (orderTicket: OrderTicket) => Promise<HotelAction>;
    getTicketPrice: (orderTicket: OrderTicket) => HotelAction;
}

interface Props extends ActionProps, RouteComponentProps<any> {
    order: Order;
    search: Search;
    tickets: TicketMap;
    error: string;
    loading: boolean;
    orderTicketLoading: boolean;
    orderTicketInProcess: OrderTicket;
    pauseOrdering: boolean;
    orderTicketLoadingStart: number;
    orderTicketPriceInfo: OrderTicketPriceInfo;
}

interface State {
    focusedInput: any;
}

class Tickets extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            focusedInput: 'startDate',
        };
    }

    public render(): JSX.Element {
        return <div className="hotel-listing-c">
            <div className="package-container">
                {this.renderTickets()}
            </div>
        </div>;
    }


    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, prevContext: any): void {
        if (!this.props.orderTicketInProcess) {
            const orderTicket = this.getDefaultOrderTicket();
            if (orderTicket && this.props.order) {
                this.props.getTicketPrice(orderTicket);
                this.props.loadOrderTicketPrice(orderTicket);
            }
        }
    }

    private getDefaultOrderTicket() {
        const ticket = this.defaultTicket();
        if (!ticket) {
            return null;
        }

        return {
            ticketId: ticket.id,
            quantityChildren: 1,
            quantityAdults: 1,
            firstDate: moment.max(
                MIN_FIRST_DATE.clone().add(1, 'month'),
                moment().add(1, 'day')
            ).format("YYYY-MM-DD"),
            ticketName: ticket.name,
            ...ZERO_TOTALS
        } as OrderTicket;
    }

    private getTickets(): Ticket[] {
        const search = this.props.search;
        const destination = search.destination;
        return ticketsForDestination(this.props.tickets, destination);
    }

    private defaultTicket(): Ticket | null {
        return this.getTickets().find(t => t.name === "One Park Per Day" && t.days === 3);
    }

    private getInProcessTicket(): Ticket | null {
        const orderTicket = this.getOrderTicket();
        return this.getTickets().find(t => t.id === orderTicket.ticketId) || this.defaultTicket();
    }

    private updateOrderTicketFor(days: number | null, name: string | null): void {
        const ticket = this.getInProcessTicket();
        days = days || ticket.days;
        name = name || ticket.name;
        const newTicket = this.getTickets().find(t => t.days === days && t.name === name);
        const orderTicket = this.getOrderTicket();
        orderTicket.ticketId = newTicket.id;
        this.props.loadOrderTicketPrice(orderTicket);
    }

    private updateOrderTicketQuantities(adult: number, child: number) {
        const orderTicket = this.getOrderTicket();
        orderTicket.quantityAdults = adult;
        orderTicket.quantityChildren = child;
        this.props.loadOrderTicketPrice(orderTicket);
    }

    private getOrderTicket(): OrderTicket {
        if (!this.props.orderTicketInProcess) {
            return this.getDefaultOrderTicket();
        } else {
            return this.props.orderTicketInProcess;
        }
    }

    public renderDays(): JSX.Element {
        const search = this.props.search;
        const destination = search.destination;
        const destinationTickets = ticketsForDestination(this.props.tickets, destination);
        const ticketDays = _(destinationTickets).map("days")
            .uniq()
            .sortBy()
            .value();
        const ticket = this.getInProcessTicket();
        return (
            <Panel bsStyle="primary">
                <Panel.Heading>Select the Number of Days</Panel.Heading>
                <Panel.Body className="day-select">
                {_.map(ticketDays, day => {
                    return (
                        <div key={day} className="day" onClick={() => this.updateOrderTicketFor(day, null)}>
                            <label>
                                <div>{day}</div>
                                <input
                                  type="radio"
                                  name="ticket-days"
                                  onChange={() => null}
                                  checked={ticket.days === day} />
                            </label>
                        </div>
                    )
                })}
                </Panel.Body>
            </Panel>
        )
    }

    public renderTicketNames(): JSX.Element {
        const search = this.props.search;
        const destination = search.destination;
        const destinationTickets = ticketsForDestination(this.props.tickets, destination);
        const ticketTypes = _(destinationTickets).map("name")
            .uniq()
            .sortBy(n => n.indexOf("Hopper") > -1 ? 0 : 1)
            .value();
        const ticket = this.getInProcessTicket();
        return (
            <Panel bsStyle="primary">
                <Panel.Heading>Select Your Theme Park Tickets</Panel.Heading>
                <Panel.Body className="day-select">
                    {_.map(ticketTypes, ticketType => {
                        return (
                            <div key={ticketType} className="day" onClick={() => this.updateOrderTicketFor(null, ticketType)}>
                                <label>
                                    <div>{ticketType}</div>
                                    <input
                                        type="radio"
                                        name="ticket-names"
                                        onChange={() => null}
                                        checked={ticket.name === ticketType} />
                                </label>
                            </div>
                        )
                    })}
                </Panel.Body>
            </Panel>
        )
    }

    public renderNumberOfTickets(): JSX.Element {
        const orderTicket = this.getOrderTicket();
        return (
            <Panel bsStyle="primary">
                <Panel.Heading>Select the Number of Tickets</Panel.Heading>
                <Panel.Body className="day-select">
                    <PlusMinusPicker
                        label="Ages 10 and up"
                        value={orderTicket.quantityAdults}
                        onChange={n => this.updateOrderTicketQuantities(n, orderTicket.quantityChildren)}
                    />
                    <PlusMinusPicker
                        label="Ages 3-9"
                        value={orderTicket.quantityChildren}
                        onChange={n => this.updateOrderTicketQuantities(orderTicket.quantityAdults, n)}
                    />
                </Panel.Body>
            </Panel>
        )
    }

    public renderCalendar(): JSX.Element {
        const orderTicket = this.getOrderTicket();
        const ticket = this.getInProcessTicket();
        const lastDate = this.props.orderTicketPriceInfo ?
            moment(this.props.orderTicketPriceInfo.lastDate).add(1, 'day') :
            moment().add(45, 'weeks');
        const firstDate = moment.max(moment(), MIN_FIRST_DATE);
        const endOffsetDays = Math.max(ticket.validRange, ticket.days) - 1;
        const smallDevice = window.matchMedia('(max-width: 400px)').matches;
        const startDate = moment.max(moment(orderTicket.firstDate), moment().add(1, 'day'), MIN_FIRST_DATE);
        return (
            <Panel bsStyle="primary">
                <Panel.Heading>Select your First Date in the Park</Panel.Heading>
                <Panel.Body className="calendar-select">
                    <DayPickerRangeController
                        startDate={startDate}
                        endDate={moment(orderTicket.firstDate).add(endOffsetDays, 'days')}
                        onDatesChange={({startDate, endDate}: {startDate: moment.Moment, endDate: moment.Moment}) => {
                            if (startDate && endDate) {
                                orderTicket.firstDate = startDate.format("YYYY-MM-DD");
                                this.props.loadOrderTicketPrice(orderTicket);
                            }
                        }}
                        focusedInput={this.state.focusedInput}
                        onFocusChange={(focused: any) => {
                            this.setState({ focusedInput: focused || 'startDate' });
                        }}
                        withPortal={false}
                        numberOfMonths={smallDevice ? 1 : 2}
                        hideKeyboardShortcutsPanel={true}
                        startDateOffset={day => day}
                        isOutsideRange={day => firstDate.isAfter(day) || lastDate.isBefore(day)}
                        isDayHighlighted={() => false}
                        enableOutsideDays={false}
                        endDateOffset={day => day.add(endOffsetDays, 'days')}
                    />
                    <div>Note: highlighted dates are your ticket valid dates</div>
                </Panel.Body>
            </Panel>
        )
    }

    public renderSelectionSummary(): JSX.Element {
        const now = moment().valueOf();
        if (this.props.orderTicketLoading && now - this.props.orderTicketLoadingStart > 1500) {
            return <LoadingOverlay/>;
        }

        const ticket = this.getInProcessTicket();
        const orderTicket = this.getOrderTicket();
        const priceInfo = this.props.orderTicketPriceInfo;
        if (!ticket || !orderTicket || !priceInfo) {
            return null;
        }



        return (
            <Panel bsStyle="primary" >
                <Panel.Heading>Current Selections</Panel.Heading>
                <Panel.Body>
                    <div className="cart">
                        <label>Ticket: {ticket.days}-Day {ticket.name}</label>
                        {orderTicket.quantityAdults && (
                            <div>
                                <span className="ticket-type">{orderTicket.quantityAdults} x Ages 10+</span>
                                <span className="ticket-subtotal">({moneyFormat(priceInfo.adultSubtotal)})</span>
                            </div>)}
                        {orderTicket.quantityChildren && (
                            <div>
                                <span className="ticket-type">{orderTicket.quantityChildren} x Ages 9-</span>
                                <span className="ticket-subtotal">({moneyFormat(priceInfo.childSubtotal)})</span>
                            </div>)}
                        <div className="subtotal">Ticket Subtotal: {moneyFormat(orderTicket.subTotal)}</div>
                        <Button bsStyle="success" onClick={() => this.addTicketToOrder()}>Add to Order</Button>
                    </div>
                </Panel.Body>
            </Panel>
        )
    }

    public renderCart(): JSX.Element {
        if (!this.props.order) {
            return null;
        }
        return (
            <Panel bsStyle="primary" className="cart">
                <Panel.Heading>Tickets</Panel.Heading>
                <Panel.Body>
                    <Cart/>
                    <h3>Order Subtotal</h3>
                    <Row>
                        <Col xs={6} className="subtotal">{moneyFormat(this.props.order.subTotal)}</Col>
                        <Col xs={6} style={{textAlign: "right"}}>
                            <Button bsStyle="success"
                                    disabled={size(this.props.order.tickets) === 0}
                                    onClick={() => this.updateAndReview()}>Review Order</Button>
                        </Col>
                    </Row>
                </Panel.Body>
            </Panel>
        );
    }

    public renderTickets(): JSX.Element {
        if (this.props.loading || !this.props.order) {
            return <LoadingOverlay/>;
        }

        const search = this.props.search;
        const destination = search.destination;
        let destinationLogo = DL_LOGO;
        if (destination.indexOf("Disneyland") === -1) {
            destinationLogo = DW_LOGO;
        }

        return (
            <div className="tickets">
                {this.props.error && <Alert bsStyle="warning">{this.props.error}</Alert>}
                {this.props.pauseOrdering ? (
                    <Alert bsStyle="info">
                        <div>Your tickets have been added to your order.</div>
                      <div><Button onClick={() => this.props.setPauseOrdering(false)} >Add More Tickets</Button></div>
                    </Alert>
                ) : (
                    <div>
                        {this.renderDays()}
                        {this.renderTicketNames()}
                        {this.renderNumberOfTickets()}
                        {this.renderCalendar()}
                        {this.renderSelectionSummary()}
                    </div>
                )}
                {this.renderCart()}
            </div>
        );
    }

    private addTicketToOrder() {
        const orderTicket = this.getOrderTicket();
        const order = this.props.order;
        order.tickets.push(orderTicket);
        order.ticketsSelected = true;
        this.props.setPauseOrdering(false); // if true - show separate block (look setPauseOrdering in client\src\actions\hotels.ts)
        this.props.getTicketPrice(null);
        this.props.updateOrder(order);
    }

    private updateAndReview() {
        this.props.updateOrder(this.props.order)
          .then(() => this.props.history.push("/summary"));
    }
}

export interface PlusMinusPickerProps {
    label: string;
    value: number;
    onChange: (n: number) => void;
}

const PlusMinusPicker: React.SFC<PlusMinusPickerProps> = ({label, value, onChange}) => {
    const incrementBy = (by: number) => () => onChange(Math.max(value + by, 0));
    return (
        <div className="plus-minus-picker">
            <label>{label}</label>
            <div>
                <i className="fa fa-minus" onClick={incrementBy(-1)} />
                <span>{value}</span>
                <i className="fa fa-plus" onClick={incrementBy(1)} />
            </div>
        </div>
    )
};

const connected = connect((state: ApplicationState) => ({
    order: state.hotels.order,
    search: state.hotels.searchCriteria,
    tickets: state.config.tickets,
    loading: state.hotels.loading || state.hotels.orderLoading || state.hotels.searchLoading || state.config.loading,
    orderTicketLoading: state.hotels.orderTicketLoading,
    orderTicketInProcess: state.hotels.orderTicketInProcess,
    error: state.hotels.errorMessage,
    pauseOrdering: state.hotels.pauseOrdering,
    orderTicketLoadingStart: state.hotels.orderTicketLoadingStart,
    orderTicketPriceInfo: state.hotels.orderTicketPriceInfo,
}), {
    updateOrder,
    loadOrderTicketPrice,
    setPauseOrdering,
    getTicketPrice,
})(Tickets);

export default withRouter<any>(connected);



// WEBPACK FOOTER //
// ./src/components/Tickets.tsx